<template>
  <div class="ps-grid-2 card-item origin-base-form ps-supply-form">
    <div class="title-box ps-grid-full">
      <span class="title-text">补充材料</span>
      <span class="btn-action-group"></span>
    </div>
      <div class="ps-field ps-grid-full">
        <label><span class="req">*</span> 补充视频类型</label>
        <a-radio-group
          name="radioGroup"
          :default-value="0"
          :disabled="isEdit"
          v-model="info.type"
          @change="handleTypeChange"
        >
          <a-radio value="0">本地视频</a-radio>
          <a-radio value="1">超链接</a-radio>
        </a-radio-group>
      </div>

      <template v-if="info.type == 0">
        <div class="ps-field ps-grid-full">
          <label><span class="req">*</span> 思政微课视频</label>
          <a-upload
            :file-list="fileList"
            accept=".mp4"
            :remove="(file, fileList) => handleRemove(file, fileList)"
            :disabled="isEdit || loading"
            :before-upload="(file, fileList) => beforeUpload(file, fileList)"
          >
            <button
              type="button"
              class="ps-upload-btn"
              :disabled="isEdit || loading"
            >
              <a-icon type="upload" />
              {{ loading ? "上传中..." : "上传附件" }}
            </button>
            <span class="ps-file-note">请上传视频</span>
          </a-upload>
        </div>
      </template>

      <template v-else>
        <div class="ps-field">
          <label><span class="req">*</span> 超链接名称</label>
          <a-input v-model="info.name" placeholder="请输入超链接名称" />
        </div>
        <div class="ps-field">
          <label><span class="req">*</span> 思政微课超链接</label>
          <a-input v-model="info.filePath" placeholder="请输入超链接地址" />
        </div>
      </template>

      <div class="ps-field ps-grid-full">
        <label><span class="req">*</span> 思政元素</label>
        <a-select
          mode="tags"
          style="width: 100%"
          :disabled="isEdit"
          v-model="info && info.ideologicalElement"
          placeholder="请选择思政元素"
        >
          <a-select-option
            v-for="item in ysList"
            :key="item.name"
            :value="item.name"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
  </div>
</template>

<script>
import { fileUpdate } from "../../api/index";
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import { baseURL } from "@/utils/request.js";
export default {
  name: "",
  components: {},
  //   props: {
  //     fileLists: {
  //       type: Array,
  //     },
  //     oldInfos:{
  //     	type: Object,
  //     },
  //     isEdit:{
  //       type:Boolean,
  //     }
  //   },
  watch: {
    "oldInfos.id": {
      handler(newValue, oldValue) {
        // console.log(newValue, "9999999999999999");
        if (newValue != null) {
          //   this.oldInfo=newValue;
          // console.log(this.oldInfos.type);
          // if(this.$parent.editInfo && this.$parent.editInfo?.type == "preview"){
          //  this.isEdit =true;
          // }else{
          //    this.isEdit =false;
          // }
          this.isEdit = false;
          //  this.getbq();
          //   this.addTeacher();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
      immediate: true,
    },
    isbj: {
      handler(newValue, oldValue) {
        console.log(newValue, "我是");
        // this.isEdit =newValue;
      },
      immediate: true,
    },
  },
  props: {
    oldInfos: {
      type: Object,
    },
    isbj: {
      type: Boolean,
      defalt: true,
    },
  },
  data() {
    return {
      info: {
        ideologicalElement: [],
        type: "0",
      },
      ysList: [],
      //    applyFiles: [],
      path: baseURL,
      loading: false,
      type4: false,
      type5: false,
      type6: false,
      submitLoading: null,
      fileList: [],
      isEdit: false,
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getysList();
    if (this.oldInfos) {
      this.info.ideologicalElement = this.oldInfos.ideologicalElement;
    }
    //    let oldInfo = JSON.parse(
    //     sessionStorage.getItem(`step${this.$store.state.user.id}`)
    //   );
    //   if(oldInfo){
    //     this.oldInfo=oldInfo;
    //     // this.isEdit = oldInfo?.type == "preview";
    //   }
    //   console.log(this.oldInfo,"11111111");
    //	    if(this.oldInfo && this.oldInfo.ideologicalElement!=''){
    //    	let ideologicalElement=this.oldInfo.ideologicalElement;
    //    	if(ideologicalElement.indexOf(",")!='-1'){
    //    		 this.info.ideologicalElement=ideologicalElement.split(',');
    //    	}else{
    //    		 let arr=[];
    //    		 arr.push(ideologicalElement);
    //    		 this.info.ideologicalElement=arr;
    //    	}
    //    	if(this.oldInfo &&  Array.isArray(this.oldInfo.ideologicalElement) && this.oldInfo.ideologicalElement.length > 0){
    //    		this.info.ideologicalElement=this.oldInfo.ideologicalElement;
    //    	}
    //    }
    //   this.fileList=this.fileLists;
    //	  console.log(this.oldInfo,"11111111");
    //   if(this.oldInfo){
    //   	 this.getbq();
    //   }
  },
  methods: {
    getbq() {
      getAction("/lxBase/lxApplyResource/getResourceByApplyId", {
        applyId: this.oldInfos.id,
      }).then((res) => {
        if (res.code === 200) {
          console.log(this.oldInfos.hasResource);
          if (
            res.result.filePath != "" &&
            res.result.filePath != "null" &&
            res.result.filePath != undefined
          ) {
            this.fileList = [];
            let fileItem = {};
            fileItem.path = res.result.filePath;
            fileItem.name = res.result.name;
            fileItem.uid = -100;
            this.fileList.push(fileItem);
          }
          if (res.result && res.result.ideologicalElement) {
            let ideologicalElement = res.result.ideologicalElement;
            if (ideologicalElement.indexOf(",") != "-1") {
              this.info.ideologicalElement = ideologicalElement.split(",");
            } else {
              let arr = [];
              arr.push(ideologicalElement);
              this.info.ideologicalElement = arr;
            }
          }
        }
      });
    },
    getysList() {
      getAction("/infrastructure/lxIdeologicalElement/list", {}).then((res) => {
        //			console.log(res);
        if (res.code === 200) {
          let data = res.result.records;
          if (data) {
            this.ysList = data;
          }
        }
      });
    },
    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file, fileList) {
      this.handleUpload(file);
      return false;
    },
    handleUpload(file) {
      if (this.fileList.length >= 1) {
        this.$message.error("思政微课只能上传一个文件,请移除后再上传");
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.fileList.push(fileItem);
          this.loading = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },
    upStep2() {
      this.$emit("upStep2", this.fileList, this.info);
    },

    submit() {
      if (this.loading) {
        this.$message.warning("文件正在上传，请上传成功后提交");
      } else {
        if (this.fileList.length == 0) {
          this.$message.info("请上传思政微课");
          return false;
        }
        if (this.info.ideologicalElement.length == 0) {
          this.$message.info("请添加思政元素");
          return false;
        }
        //  console.log(this.fileList,"11111");
        let params = {
          ideologicalElement: this.info.ideologicalElement.join(),
          filePath: this.fileList[0].path,
          name: this.fileList[0].name,
          applyId: this.oldInfos.id,
        };
        let that = this;
        postAction("/lxBase/lxApplyResource/saveOrUpdate", params).then(
          (res) => {
            //			console.log(res);
            if (res.code === 200) {
              that.$message.success("保存成功");
              that.$router.push({ name: "szMicroClass" });
              window.sessionStorage.removeItem(
                `step${this.$store.state.user.id}`
              );
              //    that.$emit("submit", that.fileList, that.info);
            }
          }
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/components/projectShell/updatePage.scss";
.card-item{
  padding:0px!important;
  box-shadow: none!important;
}
.ps-supply-form {
  margin-bottom: 0;
}
.ps-compare-link {
  margin-left: 10px;
  display: inline-block;
  color: #2155b5;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
}
</style>
